/** Forfait de base inclus (#45, PAR-38) : les quantités sont des données (BETA-15), `null` tant qu’elles sont inconnues. */
export type TypeAction = 'rendezVous' | 'sms' | 'appels';
export type ForfaitInclus = Readonly<Record<TypeAction, number | null>>;
export type Consommation = Readonly<Record<TypeAction, number>>;

export interface LigneCompteur {
  action: TypeAction;
  libelle: string;
  consomme: number;
  inclus: number | null;
  restant: number | null;
  depasse: boolean;
}

const ACTIONS: readonly { action: TypeAction; libelle: string }[] = [
  { action: 'rendezVous', libelle: 'Rendez-vous physiques' },
  { action: 'sms', libelle: 'SMS' },
  { action: 'appels', libelle: 'Appels' },
];

export function compteurForfait(inclus: ForfaitInclus, consomme: Consommation): LigneCompteur[] {
  return ACTIONS.map(({ action, libelle }) => {
    const prevu = inclus[action];
    const fait = consomme[action];
    return {
      action,
      libelle,
      consomme: fait,
      inclus: prevu,
      restant: prevu === null ? null : Math.max(0, prevu - fait),
      depasse: prevu !== null && fait > prevu,
    };
  });
}
